export const licenseTiers = ['starter', 'standard', 'pro', 'pro plus'] as const

export const licenseTerms = ['monthly', 'yearly'] as const

export type AllLicenseTier = (typeof licenseTiers)[number]
export type LicenseTier = Exclude<AllLicenseTier, 'starter'>
export type LicenseTerm = (typeof licenseTerms)[number]

export type LicenseLabel = 'demo' | `${LicenseTier} ${'monthly' | 'annual'}`

export function getDisplay(
    tier: AllLicenseTier,
    term: LicenseTerm = 'monthly'
): LicenseLabel {
    if (tier == 'starter') return 'demo'

    return `${tier} ${term === 'yearly' ? 'annual' : term}` as LicenseLabel
}

export type LicenseOption = {
    label: LicenseLabel
    tier: AllLicenseTier
    term: LicenseTerm
}

export function getAllLicenseTypes({
    exclude_starter,
    only_term,
}: {
    exclude_starter?: true
    only_term?: LicenseTerm
}): LicenseOption[] {
    const options: Set<LicenseOption> = new Set()

    for (const tier of licenseTiers) {
        if (tier === 'starter') {
            if (!exclude_starter) {
                options.add({
                    label: getDisplay(tier),
                    tier,
                    term: 'monthly',
                })
            }
            continue
        }
        if (only_term) {
            options.add({
                label: getDisplay(tier, only_term),
                tier,
                term: only_term,
            })
            continue
        }
        for (const term of licenseTerms) {
            options.add({
                label: getDisplay(tier, term),
                tier,
                term,
            })
        }
    }

    return Array.from(options)
}
